import { meetsAxiosProtected as axios } from '../httpInstance/http'

export const postWhiteboardData = (roomName, data, id) => {
    let body
    if (id) {
        body = {
            room_name: roomName,
            id,
            data,
        }
    } else {
        body = {
            room_name: roomName,
            data,
        }
    }
    return axios.post(`/whiteboard/slide/add`, body)
}

export const getWhiteboardData = roomName => {
    return axios.get(`whiteboard/slide?room_name=${roomName}`)
}

export const getWhiteboardCode = roomName => {
    return axios.get(`/${roomName}/whiteboard/code`)
}
